import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';
import ThemeCustom from './../../../../themes/custom';

const styles = theme => ({
  root: {
    paddingTop: theme.spacing.unit / 2,
    paddingBottom: theme.spacing.unit / 2,
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    borderRadius: theme.spacing.unit / 2
  },
  primary: {
    color: theme.palette.primary.contrastText,
    background: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.primary.dark
    }
  },
  secondary: {
    color: theme.palette.secondary.contrastText,
    background: theme.palette.secondary.main,
    '&:hover': {
      background: theme.palette.secondary.dark
    }
  },
  success: {
    color: ThemeCustom.palette.success.contrastText,
    background: ThemeCustom.palette.success.main,
    '&:hover': {
      background: ThemeCustom.palette.success.dark
    }
  },
  info: {
    color: ThemeCustom.palette.info.contrastText,
    background: ThemeCustom.palette.info.main,
    '&:hover': {
      background: ThemeCustom.palette.info.dark
    }
  },
  warning: {
    color: ThemeCustom.palette.warning.contrastText,
    background: ThemeCustom.palette.warning.main,
    '&:hover': {
      background: ThemeCustom.palette.warning.dark
    }
  },
  danger: {
    color: ThemeCustom.palette.danger.contrastText,
    background: ThemeCustom.palette.danger.main,
    '&:hover': {
      background: ThemeCustom.palette.danger.dark
    }
  }
});

const Label = ({ children, variant, classes }) => {

  const _variant = variant ? classes[variant] : null;

  return (
    <span className={ classNames(_variant, classes.root ) }>
      { children }
    </span>
  )

}

Label.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'info', 'warning', 'danger'])
};

export default withStyles(styles)(Label);
